import React from 'react';
import { Skeleton } from '../Skeleton';

const CertificateDetailsLoader = () => {
  return (
    <div className="row align-items-center">
      <div className="col-sm-6 col-12">
        <div className="certificateDtlsLeft">
          <Skeleton variant="rectangular" width={'100%'} height={400} />
        </div>
      </div>
      <div className="col-sm-6 col-12 mt-md-0 mt-5">
        <h1 className="text-black fw-medium fs-2 fw-medium">
          <Skeleton variant="text" width={'90%'} height={30} />
        </h1>
        <h2 className="text-black fw-normal fs-4 mt-1">
          <Skeleton variant="text" width={'80%'} height={30} />
        </h2>

        <h4 className="text-dark fw-normal fs-5 mt-2">
          <Skeleton variant="text" width={'60%'} height={30} />
        </h4>

        <h1 className="text-black fw-medium fs-2 fw-medium mt-4">
          <Skeleton variant="text" width={'70%'} height={20} />
        </h1>
        <h2 className="text-black fw-normal fs-4 mt-1">
          <Skeleton variant="text" width={'50%'} height={20} />
        </h2>

        <h4 className="text-dark fw-normal fs-5 mt-2">
          <Skeleton variant="text" width={'60%'} height={20} />
        </h4>
      </div>
    </div>
  );
};

export default CertificateDetailsLoader;
